export default __webpack_public_path__ + "static/EngageLogo-da59acb2560d9fcfca606e23ac8e6c9a.png";